/** Options passed to navigate (e.g. React Router's replace). */
export type NavigateOptions = { replace?: boolean };

/**
 * Allows non-React code (store, sagas) to trigger in-app navigation to the model selector.
 * App sets the navigate function when the router mounts; if not set, goToModelSelector falls back to location.assign.
 */
let navigateRef: ((path: string, options?: NavigateOptions) => void) | null = null;

export function setNavigate(navigate: ((path: string, options?: NavigateOptions) => void) | null): void {
    navigateRef = navigate;
}

export function hasNavigate(): boolean {
    return navigateRef != null;
}

export function getNavigate(): ((path: string, options?: NavigateOptions) => void) | null {
    return navigateRef;
}
